export default __webpack_public_path__ + "static/media/background-plant4.4ff7f382.png";